// Native
import { useState } from "react"

// Components
import { Badge, ButtonGroup, Tag, Td } from "@chakra-ui/react"
import { Dash, IconButton, Row, Scope, Section, Show, Table } from "components"

// Config
import { Moment, Mask, Enums } from "config"

// Hooks
import { useConsultantsWithdraws } from "hooks"

// Screens
import { Withdraw } from "screens"

export default function Withdraws({ data }){

    const [ page, setPage ] = useState(1)
    const withdrawals = useConsultantsWithdraws(data?.id, page)
    const [ withdraw, setWithdraw ] = useState()

    const columns = [
        { children: '', isNumeric: true }, 
        { children: 'Status' }, 
        { children: 'Valor', isNumeric: true }, 
        { children: 'Aprovado em', isNumeric: true }, 
        { children: 'Aprovado por', isNumeric: true }, 
        { children: 'Solicitação', isNumeric: true }, 
        { isNumeric: true }
    ]

    return(
    <>
    <Section title="Pedidos de saque">
        <ButtonGroup size="xs" isDisabled={withdrawals.isFetching}>
            <IconButton icon="refresh" isLoading={withdrawals.isFetching} onClick={withdrawals.refetch} />
        </ButtonGroup>
    </Section>

    <Table columns={columns} setPage={setPage} meta={withdrawals.data?.meta} loading={withdrawals.isLoading}>
        { withdrawals.data?.data?.map(item => <Item key={item.id} data={item} onClick={() => setWithdraw(item)} />) }
    </Table>

    {/* Screens */}
    <Withdraw.View isOpen={!!withdraw} data={withdraw} onClose={() => setWithdraw(false)} />
    </>
    )
}

const Item = ({ data:item, ...props }) => {
    return(
    <Row {...props}>
        <Td isNumeric children={item.cod} />
        <Td><Tag size="sm" colorScheme={Enums.WithdrawStatus.data(item.status).colorScheme} children={item.status_label} /></Td>
        <Td isNumeric><Badge children={`R$ ${Mask.price(item.value)}`} /></Td>
        <Td isNumeric fontSize="xs"><Dash children={item.sent_at && Moment(item.sent_at).calendar()} /></Td>
        <Td></Td>
        <Td isNumeric fontSize="xs"><Dash children={item.created_at && Moment(item.created_at).calendar()} /></Td>
        <Td>
            <Scope role="manage_financial">
                <Show visible={[Enums.WithdrawStatus.ANALYZING].includes(item.status)}>
                    <ButtonGroup size="xs">
                        <IconButton colorScheme="green" icon="check" label="Aprovar saque" />
                        <IconButton colorScheme="red" icon="close" label="Rejeitar saque" />
                    </ButtonGroup>
                </Show>
            </Scope>
        </Td>
    </Row>
    )
}